/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { format } from "date-fns";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idUnidade: string;
  idLeadCorretor: string;
}

export function useCadastrarProposta() {
  const postData = async (props: Props) => {
    const RESUMO_PAGAMENTO = `${backofficeEnviroment}/common/oportunidades-lead/cadastrar-proposta/vivaz/v1/${props.idLeadCorretor}/${props.idUnidade}`;
    const { data } = await instance.post(RESUMO_PAGAMENTO, {
      IdUnidade: props.idUnidade,
      IdLeadCorretor: props.idLeadCorretor,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      // toast.success("Proposta criada com sucesso!");
    },
    onError: (error: any) => {
      notificarErroApi("Erro ao criar proposta", error);
    },
  });

  return mutation;
}
